export default __webpack_public_path__ + "static/media/arrow-button.6fb180aa.svg";